import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { RouterModule } from '@angular/router';
import { AccordionService } from './accordion.service';

@NgModule({
  declarations: [AccordionComponent],
  imports: [CommonModule, RouterModule],
  providers: [AccordionService],
  exports: [AccordionComponent]
})
export class AccordionModuleModule {}
